// src/PrivacyPolicy.js
import React from 'react';
import './privacypolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p><strong>Effective Date:</strong> 27, May 2025</p>
        <p>Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our services, including our mobile and web applications, websites, and related services (collectively, "Services").</p>
        <p>Please read this Privacy Policy carefully. By using our Services, you agree to the collection and use of information in accordance with this policy.</p>

        <h2>1. Who We Are</h2>
        <p>Socie Pro AI is a productivity and automation tool that helps users manage their digital tasks with AI-powered assistance. We are committed to protecting your privacy and ensuring transparency in how we handle your data.</p>

        <h2>2. Information We Collect</h2>

        <h3>2.1 Information You Provide to Us</h3>
        <p>When you interact with our Services, we may collect the following information:</p>
        <p><strong>Account Information:</strong> Name, email address, and other information you enter during account registration.</p>
        <p><strong>Content Data:</strong> Information you submit while using our services, including text, images, social media posts, or files.</p>
        <p><strong>Support Requests:</strong> When you contact our support team, we collect your name, email, and any additional details you provide.</p>

        <h3>2.2 Information We Collect Automatically</h3>
        <p>When you use Socie Pro AI, we may automatically collect:</p>
        <p><strong>Device and Log Data:</strong> IP address, browser type, operating system, timestamps, and pages viewed.</p>
        <p><strong>Usage Data:</strong> How you interact with our Services, including features used, actions taken, and crash reports.</p>
        <p><strong>Cookies and Similar Technologies:</strong> We use cookies, local storage, and similar tools to enhance user experience and analyze usage patterns.</p>

        <h3>2.3 Information from Third Parties</h3>
        <p>If you choose to connect your account with third-party services (e.g., Google, Facebook, or social media accounts), we may collect certain information such as:</p>
        <p>Public profile information</p>
        <p>Email address</p>
        <p>Any other permissions granted by you</p>

        <h2>3. How We Use Your Information</h2>
        <p>We use your data to:</p>
        <p>Provide, operate, and improve our Services</p>
        <p>Authenticate users and provide secure access</p>
        <p>Personalize the user experience</p>
        <p>Analyze usage to improve functionality and performance</p>
        <p>Communicate with you (including support and service updates)</p>
        <p>Comply with legal obligations</p>


        <h2>4. Legal Basis for Processing (For Users in the EEA)</h2>
        <p>We process your personal data under the following legal bases:</p>
        <p><strong>Performance of a Contract:</strong> To provide the Services you request.</p>
        <p><strong>Legitimate Interests:</strong> To operate and improve our Services.</p>
        <p><strong>Consent:</strong> For specific features like marketing communications.</p>
        <p><strong>Legal Obligation:</strong> When processing is required to comply with laws.</p>

        <h2>5. Sharing of Your Information</h2>
        <p>We do not sell your personal information. We may share it with:</p>
        <p><strong>Service Providers:</strong> Companies we use to deliver services on our behalf (e.g., hosting, analytics, customer support).</p>
        <p><strong>Legal Authorities:</strong> If required by law or to protect legal rights.</p>
        <p><strong>Business Transfers:</strong> If we are involved in a merger, sale, or acquisition.</p>

        <h2>6. Data Retention</h2>
        <p>We retain personal data only as long as necessary for the purposes set out in this policy. We may retain usage data for analytics purposes even after account deletion, but it will be anonymized where applicable.</p>

        <h2>7. International Data Transfers</h2>
        <p>Socie Pro AI is based in [Insert Country]. Your information may be transferred to and processed in countries outside of your own. We ensure such transfers are compliant with applicable data protection laws.</p>

        <h2>8. Your Rights and Choices</h2>
        <p>Depending on your location, you may have the right to:</p>
        <p>Access, correct, or delete your personal data</p>
        <p>Object to or restrict data processing</p>
        <p>Withdraw your consent at any time</p>
        <p>Export your data</p>
        <p>To exercise your rights, contact us at info@sociepro.ai</p>

        <h2>9. Security</h2>
        <p>We implement industry-standard security measures to protect your data. However, no method of transmission or storage is 100% secure. You use our Services at your own risk.</p>

        <h2>10. Cookies and Tracking Technologies</h2>
        <p>We use cookies and similar technologies to:</p>
        <p>Remember your preferences</p>
        <p>Improve user experience</p>
        <p>Analyze site traffic</p>
        <p>You can manage or disable cookies in your browser settings.</p>

        <h2>11. Links to Third-Party Services</h2>
        <p>Our Services may contain links to third-party websites or services. We are not responsible for their content or privacy practices. Please review their privacy policies.</p>

        <h2>12. Changes to This Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time. We will notify you by updating the "Effective Date" or via email or app notification if changes are significant.</p>

        <h2>13. Contact Us</h2>
        <p>If you have any questions or concerns regarding this Privacy Policy, contact us at:</p>
        <p>
          Socie Pro AI<br />
          Email: info@sociepro.ai<br />
          Website: https://www.sociepro.ai
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;



